module.exports = __webpack_public_path__ + "img/interface OneB Clock-server_2 prew.00196c16.jpg";